import { TRAFFIC_SOURCE } from '../../../../server/src/constants/trafficSource'
import { LINK_SOURCE } from '../../constants'

const getTrafficSource = (isAdmin: boolean, source: LINK_SOURCE) => {
  if (isAdmin && source === LINK_SOURCE.COPY) {
    return TRAFFIC_SOURCE.EXTERNAL_DEEPLINK_WEB_COPY_CREATOR
  }
  if (isAdmin && source === LINK_SOURCE.NATIVE) {
    return TRAFFIC_SOURCE.EXTERNAL_DEEPLINK_NATIVE_SHARE_CREATOR
  }
  if (!isAdmin && source === LINK_SOURCE.COPY) {
    return TRAFFIC_SOURCE.EXTERNAL_DEEPLINK_WEB_COPY_CONTRIBUTOR
  }
  if (!isAdmin && source === LINK_SOURCE.NATIVE) {
    return TRAFFIC_SOURCE.EXTERNAL_DEEPLINK_NATIVE_SHARE_CONTRIBUTOR
  }

  return null
}

export const addTrafficSourceParameter = (
  shareLink: string,
  isAdmin: boolean,
  source: LINK_SOURCE,
) => {
  const trafficSource = getTrafficSource(isAdmin, source)
  if (trafficSource) {
    return `${shareLink}?sr=${trafficSource}`
  }

  return shareLink
}
